"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initVideoIFramePlayersInsideModal = exports.VideoPlayerIFrame = void 0;
var utils_1 = require("./utils");
var utils_2 = require("../components/admin/topic-edit/utils");
var VideoPlayerIFrame = /** @class */ (function () {
    function VideoPlayerIFrame(selector, queryElement) {
        this._iframe = null;
        this.selector = selector;
        this.querySelector = queryElement;
    }
    VideoPlayerIFrame.prototype.queryElement = function () {
        var el = this.querySelector(this.selector);
        if (!el) {
            throw new Error("HTMLIFrameElement with selector \"".concat(this.selector, "\" not found"));
        }
        return el;
    };
    Object.defineProperty(VideoPlayerIFrame.prototype, "iframe", {
        get: function () {
            if (this._iframe !== null) {
                return this._iframe;
            }
            this._iframe = this.queryElement();
            return this._iframe;
        },
        enumerable: false,
        configurable: true
    });
    VideoPlayerIFrame.prototype.play = function () {
        var _a;
        (_a = this.iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage('{"method":"play"}', '*');
    };
    VideoPlayerIFrame.prototype.pause = function () {
        var _a;
        (_a = this.iframe.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage('{"method":"pause"}', '*');
    };
    return VideoPlayerIFrame;
}());
exports.VideoPlayerIFrame = VideoPlayerIFrame;
function initVideoIFramePlayersInsideModal(modalOpeners) {
    modalOpeners.forEach(function (modalOpener) {
        var modalSelector = (0, utils_1.parseDatasetValue)(modalOpener.dataset.target, 'target');
        var iframeSelector = (0, utils_1.parseDatasetValue)(modalOpener.dataset.iframeSelector, 'iframe-selector');
        var videoPlayer = new VideoPlayerIFrame(iframeSelector, function (selector) {
            return document.querySelector(selector);
        });
        var openModalEventFired = false;
        modalOpener.addEventListener('click', function () {
            if (openModalEventFired) {
                return;
            }
            (0, utils_2.onModalEvent)(modalSelector, 'hidden.bs.modal', function () {
                videoPlayer.pause();
            });
            openModalEventFired = true;
            setTimeout(function () {
                videoPlayer.play();
            }, 200);
        });
    });
}
exports.initVideoIFramePlayersInsideModal = initVideoIFramePlayersInsideModal;
